import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';

const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const EmploymentVerificationPage = lazy(() => import('../pages/services/employment-verification/page'));
const ReferenceVerificationPage = lazy(() => import('../pages/services/reference-verification/page'));
const EducationalVerificationPage = lazy(() => import('../pages/services/educational-verification/page'));
const AddressIdentityVerificationPage = lazy(() => import('../pages/services/address-identity-verification/page'));
const CriminalVerificationPage = lazy(() => import('../pages/services/criminal-verification/page'));
const SocialMediaVerificationPage = lazy(() => import('../pages/services/social-media-verification/page'));
const MedicalDrugsVerificationPage = lazy(() => import('../pages/services/medical-drugs-verification/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// New page imports
const IdentityVerificationPage = lazy(() => import('../pages/services/identity-verification/page'));
const UanCheckPage = lazy(() => import('../pages/services/uan-check/page'));
const AddressCheckPage = lazy(() => import('../pages/services/address-check/page'));
const FirVerificationPage = lazy(() => import('../pages/services/fir-verification/page'));
const ECourtCriminalRecordCheckPage = lazy(() => import('../pages/services/e-court-criminal-record-check/page'));
const CreditCheckCibilPage = lazy(() => import('../pages/services/credit-check-cibil/page'));
const DirectorshipCheckPage = lazy(() => import('../pages/services/directorship-check/page'));
const PoliceCheckPccPage = lazy(() => import('../pages/services/police-check-pcc/page'));
const Form16CheckPage = lazy(() => import('../pages/services/form-16-check/page'));
const Form26asCheckPage = lazy(() => import('../pages/services/form-26as-check/page'));
const PhysicalAddressCheckPage = lazy(() => import('../pages/services/physical-address-check/page'));
const CriminalBackgroundVerificationLawFirmPage = lazy(() => import('../pages/services/criminal-background-verification-law-firm/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="/about" replace />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  
  // 17 Service Routes
  {
    path: '/services/identity-verification',
    element: <IdentityVerificationPage />,
  },
  {
    path: '/services/employment-verification',
    element: <EmploymentVerificationPage />,
  },
  {
    path: '/services/uan-check',
    element: <UanCheckPage />,
  },
  {
    path: '/services/professional-reference-check',
    element: <ReferenceVerificationPage />,
  },
  {
    path: '/services/address-check',
    element: <AddressCheckPage />,
  },
  {
    path: '/services/fir-verification',
    element: <FirVerificationPage />,
  },
  {
    path: '/services/educational-verification',
    element: <EducationalVerificationPage />,
  },
  {
    path: '/services/e-court-criminal-record-check',
    element: <ECourtCriminalRecordCheckPage />,
  },
  {
    path: '/services/credit-check-cibil',
    element: <CreditCheckCibilPage />,
  },
  {
    path: '/services/directorship-check',
    element: <DirectorshipCheckPage />,
  },
  {
    path: '/services/police-check-pcc',
    element: <PoliceCheckPccPage />,
  },
  {
    path: '/services/form-16-check',
    element: <Form16CheckPage />,
  },
  {
    path: '/services/form-26as-check',
    element: <Form26asCheckPage />,
  },
  {
    path: '/services/physical-address-check',
    element: <PhysicalAddressCheckPage />,
  },
  {
    path: '/services/social-media-adverse-media-screening',
    element: <SocialMediaVerificationPage />,
  },
  {
    path: '/services/drug-test',
    element: <MedicalDrugsVerificationPage />,
  },
  {
    path: '/services/criminal-background-verification-law-firm',
    element: <CriminalBackgroundVerificationLawFirmPage />,
  },

  // Legacy Routes to avoid breaking existing setups
  {
    path: '/services/reference-verification',
    element: <ReferenceVerificationPage />,
  },
  {
    path: '/services/address-&-identity-verification',
    element: <AddressIdentityVerificationPage />,
  },
  {
    path: '/services/police-criminal-verification',
    element: <CriminalVerificationPage />,
  },
  {
    path: '/services/social-media-verification',
    element: <SocialMediaVerificationPage />,
  },

  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
